<template>
	<div>
		<v-data-table
			v-if="allVerifiers"
			:loading="loading"
			:no-data-text="$t('no-data-available')"
			:loading-text="$t('loading')"
			:items="filteredVerifiers"
			fixed-header
			hide-default-header
			dense
			:height="pageHeight(176)"
			item-key="rvDomain"
			single-expand
			:footer-props="getDataTableFooterProps('VerifiersTable')"
			:items-per-page="-1">
			<template #item="{ item, index, expand, isExpanded }">
				<tr :class="[getRowsForDataTable(index), { 'expanded-row': isExpanded }]" @click="expand(!isExpanded)">
					<td class="table-border-bottom text-left d-flex align-center">
						<v-btn small icon>
							<v-icon small color="primary">
								{{ isExpanded ? 'mdi-arrow-down-drop-circle' : 'mdi-arrow-right-drop-circle' }}
							</v-icon>
						</v-btn>
						<span style="font-weight: bold; font-size: 13px; margin-left: 2px; margin-right: 8px">
							{{ item.rvDomain }}
						</span>
						<v-chip pill x-small color="primary" class="ml-auto text--black custom-chip-size" label>
							{{ item.verifiers.length }} {{ item.verifiers.length > 1 ? $t('verifiers') : $t('verifier') }}
						</v-chip>
					</td>
				</tr>
			</template>
			<template #expanded-item="{ item }">
				<tr style="cursor: default; background-color: #fff !important">
					<td class="pa-3">
						<v-data-table
							:items="item.verifiers"
							:headers="headers"
							dense
							:items-per-page="-1"
							hide-default-footer
							class="data-table-outline"
							:height="pageHeight(95)"
							fixed-header>
							<template #item="{ item, index }">
								<tr :class="getRowsForDataTable(index)">
									<td class="text-left">
										{{ $i18n.locale ? item.shortDescription : item.shortDescriptionEsp }}
									</td>
									<td class="text-left">
										{{ item.lowValue }}
									</td>
									<td class="text-right">
										<v-menu left bottom class="py-0" offset-y transition="slide-x-transition">
											<template #activator="{ on, attrs }">
												<v-btn icon color="black" v-bind="attrs" v-on="on" class="float-right mr-2">
													<span class="mdi mdi-24px mdi-dots-horizontal mt-1"></span>
												</v-btn>
											</template>
											<v-list class="px-0" dense>
												<v-list-item link dense @click="editDrawerDetails(item)">
													<v-list-item-icon class="mx-1">
														<v-icon class="icon-img mdi-18px" color="black">mdi-eye</v-icon>
													</v-list-item-icon>
													<v-list-item-content class="font-bold" style="font-size: 14px">
														{{ $t('view') }}
													</v-list-item-content>
												</v-list-item>
												<v-divider />
												<v-list-item link dense @click="deleteVerifierById(item)">
													<v-list-item-icon class="mx-1">
														<v-icon class="icon-img mdi-18px" color="red">mdi-trash-can-outline</v-icon>
													</v-list-item-icon>
													<v-list-item-content class="font-bold" style="font-size: 14px">
														{{ $t('delete') }}
													</v-list-item-content>
												</v-list-item>
											</v-list>
										</v-menu>
									</td>
								</tr>
							</template>
						</v-data-table>
					</td>
				</tr>
			</template>
		</v-data-table>
		<DeleteDialog :dialog.sync="showDeleteDialog" @confirm="deleteVerifierConfirm" />
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { showSuccessAlert, showErrorAlert, getDataTableFooterProps, getRowsForDataTable } from '@/utils/utilities';
import DeleteDialog from '@/views/dialogs/DeleteDialog.vue';

export default {
	components: { DeleteDialog },
	data: () => ({
		loading: false,
		headerClass: 'color-header',
		showDeleteDialog: false,
		verifierIdToDelete: -1,
		headersTable: [
			{ id: 1, text: 'Description', value: 'shortDescription' },
			{ id: 2, text: '', value: '' },
			{ id: 3, text: 'Low value', value: 'lowValue' },
			{ id: 4, text: 'Actions', value: 'value', align: 'end' },
		],
	}),
	computed: {
		...mapState({
			allVerifiers: (state) => state.verifiers.allverifires,
		}),
		...mapGetters({
			appBarSearch: 'filterbar/getSearch',
			pageHeight: 'pageHeight',
			// allVerifiers: 'verifiers/getAllVerifiers',
		}),
		headers () {
			var headers = [];
			headers = [
				{
					text: this.$t('description'),
					value: 'description',
					class: this.headerClass,
					sortable: false,
					width: 200,
				},
				{
					text: this.$t('low-value'),
					value: 'lowValue',
					class: this.headerClass,
					sortable: false,
					width: 100,
				},
				{
					text: '',
					value: 'actions',
					class: this.headerClass,
					sortable: false,
					width: 100,
				},
			];
			return headers;
		},
		filteredVerifiers () {
			if (!this.appBarSearch) {
				return this.groupedVerifiers;
			}
			const searchTerm = this.appBarSearch.toLowerCase();
			return this.groupedVerifiers.reduce((result, group) => {
				if (group.rvDomain.toLowerCase().includes(searchTerm)) {
					result.push(group);
					return result;
				}
				const matchingVerifiers = group.verifiers.filter((verifier) => {
					return (
						verifier.shortDescription.toLowerCase().includes(searchTerm) ||
						verifier.shortDescriptionEsp.toLowerCase().includes(searchTerm) ||
						verifier.lowValue.toString().includes(searchTerm)
					);
				});
				if (matchingVerifiers.length > 0) {
					result.push({
						...group,
						verifiers: matchingVerifiers,
					});
				}
				return result;
			}, []);
		},
		groupedVerifiers () {
			return this.allVerifiers.reduce((groups, verifier) => {
				let group = groups.find((g) => g.rvDomain === verifier.rvDomain);
				if (!group) {
					group = { rvDomain: verifier.rvDomain, verifiers: [] };
					groups.push(group);
				}
				group.verifiers.push(verifier);
				return groups;
			}, []);
		},
	},
	async mounted () {
		await this.getAllVerifiers();
	},
	methods: {
		getRowsForDataTable,
		getDataTableFooterProps,
		closeAll () {
			Object.keys(this.$refs).forEach((k) => {
				if (this.$refs[k] && this.$refs[k].$attrs['data-open']) {
					this.$refs[k].$el.click();
				}
			});
		},
		async getAllVerifiers () {
			this.closeAll();
			this.loading = true;
			await this.$store.dispatch('verifiers/getAllVerifiers').then(() => {
				this.loading = false;
			});
			this.closeAll();
		},
		async editDrawerDetails (item) {
			await this.$store.commit('verifiers/SELECTED_VERIFIER', item);
			this.$store.commit('SET_EDIT_DETAILS_DRAWER', {
				updateDrawer: true,
				page2: 'verifier',
				item: item,
			});
		},
		async deleteVerifierById (item) {
			this.showDeleteDialog = true;
			this.verifierIdToDelete = item.id;
		},
		async deleteVerifierConfirm () {
			await this.$store.dispatch('verifiers/deleteVerifierById', this.verifierIdToDelete).then((res) => {
				if (res.data.resFlag) {
					showSuccessAlert(this.$t('success-operation'));
					this.getAllVerifiers();
					this.closeDeleteDialog();
				} else {
					showErrorAlert(this.$t('failed-operation'));
				}
			});
		},
		closeDeleteDialog () {
			this.showDeleteDialog = false;
			this.verifierIdToDelete = -1;
		},
	},
};
</script>
